module.exports = __webpack_public_path__ + "img/album21_30.a9d5aecc.jpg";